export const THEME_COLOR = '#004e96';
export const WHITE_COLOR = 'white';
export const DARK_GREY_COLOR = '#999999';
export const LIGHT_GREY_COLOR = '#eaeaea';
export const LIGHTER_GREY_COLOR = '#fafafa';
export const GREY_COLOR = '#dddddd';

export const EMAIL_FORM_NULL_VALUE = 'EMAIL_FORM_NULL_VALUE';
export const CONTACT_DETAILS_FORM = 'CONTACT_DETAILS_FORM';
export const QUALIFY_LEADS_FORM = 'QUALIFY_LEADS_FORM';
export const LOCAL_STORAGE_DATA_KEY = 'conversations';

export const SCREEN_TYPE_START = 'start';
export const SCREEN_TYPE_CONVERSATION = 'conversation';
export const SCREEN_TYPE_CONVERSATION_LIST = 'conversation_list';
export const SCREEN_TYPE_INITIAL_FORM = 'screen_type_initial_form';

export const SCREEN_TYPE_ORDER = 'order';
export const SCREEN_HELP_AND_SUPPORT = 'help-and-support';
export const SCREEN_ORDER_HELP_WITH_ORDER = 'help-with-order';
export const SCREEN_ORDER_VIEW_PREVIOUS_ORDERS = 'view-previous-order';
export const SCREEN_ORDER_ADDRESS = 'get-order-address';
export const SCREEN_ORDER_SUMMARY ='get-order-summary';
export const LOGIN_SCREEN = 'LOGIN_SCREEN';
export const EXTERNAL_HELPDESK = 'EXTERNAL_HELPDESK'

export const CONVERSATION_MESSAGE_TYPE_TEXT = 'text';
export const CONVERSATION_MESSAGE_TYPE_ACTIVITY = 'activity';

export const MESSAGE_FROM_CUSTOMER = 'customer';
export const MESSAGE_FROM_OPERATOR = 'operator';

export const CONVERSATION_TYPE_MESSENGER = 'messenger';

export const MEDIA_TYPE_GIF = 'gif';
export const MEDIA_TYPE_STICKER = 'sticker';
export const MEDIA_TYPE_TEXT = 'text';
export const MEDIA_TYPE_FILE = 'file';
export const MEDIA_TYPE_FORM = 'form';
export const MEDIA_TYPE_RATING = 'rating';
export const MEDIA_TYPE_RATING_FORM = 'rating_form';
export const MEDIA_TYPE_ORDER = 'order';
export const MEDIA_TYPE_JOURNEY = 'scenario';

export const TYPE_USER = 'user';
export const TYPE_LEAD = 'lead';

export const GetDataValue = (el, prop) => {
    return el.getAttribute('data-' + prop);
}

// return String from replaceFn
export const parsePropertyTags = (html, replaceFn) => {
    const node = document.createElement('div');
    node.innerHTML = html;
    node.querySelectorAll('no-data')
        .forEach(dataEl => {
            const name = GetDataValue(dataEl, 'name');
            const fallback = GetDataValue(dataEl, 'fallback');
            node.replaceChild(document.createTextNode(replaceFn(name, fallback)), dataEl);
        })
    return node.innerHTML;
}

// For parsing scenario description
export const parsePropertyTagsV2 = (html, replaceFn) => {
    const node = document.createElement('div');
	node.innerHTML = html;
    node.querySelectorAll("span[data-at-name='property']")
        .forEach(dataEl => {
			const targetEl = dataEl.querySelector('.rp-inserted-property');
            const name = GetDataValue(targetEl, 'property-name');
            const type = GetDataValue(targetEl, 'type');
            const propertyCategory = GetDataValue(targetEl, 'property-category');
			let getValue = replaceFn(name, type, propertyCategory)
			if(name === 'orderShippingSummary') {
				let nodeHtml = document.createElement("span")
				nodeHtml.innerHTML = getValue
				dataEl.replaceWith(nodeHtml)
			} else {
				dataEl.replaceWith(document.createTextNode(getValue))
			}
		})
		try {
			//when we do copy paste of variables from one place to other
			//we need to do this
			node.querySelectorAll("rp-prop")
			.forEach(dataEl => {
				const targetEl = dataEl
				const name = GetDataValue(targetEl, 'property-name');
				const type = GetDataValue(targetEl, 'type');
				const propertyCategory = GetDataValue(targetEl, 'property-category');
				let getValue = replaceFn(name, type, propertyCategory)
				if(name === 'orderShippingSummary') {
					let nodeHtml = document.createElement("span")
					nodeHtml.innerHTML = getValue
					dataEl.replaceWith(nodeHtml)
				} else {
					dataEl.replaceWith(document.createTextNode(getValue))
				}
			})
		} catch(e) {
			console.log(e)
		}
	
    return node.innerHTML.replace(/(?:&nbsp;){2,}/g, '&nbsp;').replace(/(<p> <\/p>)/g, '').replace(/(<p>&nbsp;<\/p>)/g, '');
}
import {
	DateTime
} from 'luxon'
export const formatTheValue = (value, type) => {
	if(value === undefined || value === '' ) return '';
	if(type === 'file') {
		try {
			const files = JSON.parse(value)
			let parseFileName = files.length == 1 ? `(Attached ${files[0].name})` : files.length >1 ? `(Attached ${files.length} files)` : ''
			return parseFileName;
		} catch(e) {
			return '';
		}
	}
	else if(type === 'date') {
		return value ?  DateTime.fromMillis(parseInt(value)).toFormat('LLLL dd, yyyy') : '';
	}
	else if(type === 'boolean') {
		return value ? 'Yes' : 'No';
	} else if(type === 'list') {
		if(value && Array.isArray(value)) {
			return value.join(", ")
		} else {
			return '' 
		}
	} else {
		return value;
	}
}

export const TONE = new Audio('https://s3-us-west-2.amazonaws.com/richpanel-assets/audio/MessageSent.mp3');
export const COMMAN_IMG_URL = "https://s3-us-west-2.amazonaws.com/richpanel-assets/"

export class RPAudioManager {

	static CONTEXT_NEW_MESSAGE = 'CONTEXT_NEW_MESSAGE';

	static initialize({ toPlaySound, isMessengerVisible }) {
		this.toPlaySound = toPlaySound;
		this.isMessengerVisible = isMessengerVisible;
	}

	static play(context) {
		if (this.toPlaySound && this.isMessengerVisible) {
			switch(context) {
				case this.CONTEXT_NEW_MESSAGE:
					TONE.play();
					return
			}
		}
	}
	
}

export const EMAIL_REQUIREMENT_OUTSIDE = 'outside';
export const EMAIL_REQUIREMENT_NEVER = 'never';
export const EMAIL_REQUIREMENT_ALWAYS = 'always';

export const delay = timeout => {
	return new Promise((res, rej) => {
		setTimeout(() => {
			res();
		}, timeout);
	})
};
export const emojiBaseURL = 'https://richpanel-assets.s3-us-west-2.amazonaws.com/assets/emojis/';
export const emojies = [
	{
		id: 1,
		name: "Terrible",
		imgUrl: "terrible.png"
	},
	{
		id: 2,
		name: "Bad",
		imgUrl: "bad.png"
	},
	{
		id: 3,
		name: "Ok",
		imgUrl: "ok.png"
	},
	{
		id: 4,
		name: "Great",
		imgUrl: "great.png"
	},
	{
		id: 5,
		name: "Amazing",
		imgUrl: "amazing.png"
	}
]

export const getKeyForSentece = (sentence) => {
	if (sentence === "The team typically replies in a day.")
		return 'IN_A_DAY';
	else if(sentence === "The team typically replies in a few minutes.")
		return 'IN_FEW_MINUTES';
	else if(sentence === "The team typically replies in a few hours.")
		return 'IN_FEW_HOURS';
	else if(sentence === "The team will reply as soon as they can")
		return 'AS_SOON_AS_THEY_CAN';
	else {
		return 'AS_SOON_AS_THEY_CAN';
	}
}

export const abbreviateNumber = (value, type='items') => {
    let newValue = value;
    if (value >= 1000) {
		value = value.toFixed(0);
        let suffixes = ["", "k", "m", "b","t"];
        let suffixNum = Math.floor( (""+value).length/3 );
        let shortValue = '';
        for (let precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000, suffixNum) ) : value).toPrecision(precision));
            let dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
            if (dotLessShortValue.length <= 2) { break; }
        }
        if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
        newValue = shortValue+suffixes[suffixNum];
    } else {
		const decimals = value - Math.floor(Number(value));
		if(type == 'items') {
			newValue =  value;
		} else {
			newValue = Number(value).toFixed(2)
		}
	}
    return newValue;
	
}

const getSelectedItemsInfo = (selectedProductsOfOrder) => {
	let items = [];
	for(let product of selectedProductsOfOrder) {
		let productInfo = orderInfo.products.find((pr)=>pr.id+':'+pr.productId === product);
		let {
			name,
			productId,
			price,
		} = productInfo;
		const item = {
			itemId: productInfo.id,
			itemLabel: name, 
			calculatedPrice: price * quantities[productInfo.id+':'+productInfo.productId],
			selectedCount: quantities[productInfo.id+':'+productInfo.productId],
			productId
		}
		items.push(item)
	}
	return items;
}
export const getTheFormattedOrderData = ( { orderInfo, selectedProducts = [] }) => {
	const orderMessageStruct = {
		storeLogoURL: '',
		orderLabel: 'Order',
		orderId: orderInfo.orderNumber,
		orderName: orderInfo.orderName,
		status: orderInfo.status,
		currency: orderInfo.currency || '$',
		orderDbId: orderInfo.id,
		appClientId: orderInfo.appClientId,
		amount: {
			label: 'AMT',
			value: orderInfo.amount,
		},
		qty: {
			label: 'ITEMS',
			value: orderInfo.products ? orderInfo.products.length : 0,
			measureLabel: 'items'
		},
		selectedItems: {
			header: 'Selected items',
			items: getSelectedItemsInfo(selectedProducts)
		},
		createdAt: orderInfo.createdAt
	}
	return orderMessageStruct;
}

export const formattedOrderDataV2 = (orderData) => {
	let orderInfo = orderData.orderInfo;
	let selectedProducts = orderData.selectedProucts;
	let quantities = orderData.quantities;
	const getSelectedItemsInfo = (selectedProductsOfOrder) => {
		let items = [];
		for(let product of selectedProductsOfOrder) {
			let productInfo = orderInfo.products.find((pr)=>pr.id+':'+pr.productId === product);
			let {
				name,
				productId,
				price,
			} = productInfo;
			const item = {
				itemId: productInfo.id,
				itemLabel: name, 
				calculatedPrice: price * quantities[productInfo.id+':'+productInfo.productId],
				selectedCount: quantities[productInfo.id+':'+productInfo.productId],
				productId
			}
			items.push(item)
		}
		return items;
	}
	const orderMessageStruct = {
		storeLogoURL: '',
		orderLabel: 'Order',
		orderId: orderInfo.orderNumber,
		status: orderInfo.status,
		currency: orderInfo.currency || '$',
		orderDbId: orderInfo.id,
		appClientId: orderInfo.appClientId,
		amount: {
			label: 'AMT',
			value: orderInfo.amount,
		},
		qty: {
			label: 'ITEMS',
			value: orderInfo.products ? orderInfo.products.length: 0,
			measureLabel: 'items'
		},
		selectedItems: {
			header: 'Selected items',
			items: getSelectedItemsInfo(selectedProducts)
		},
	}
	return orderMessageStruct
}

export const truncate = (text, options) => {
	let lengthToTruncate = 0;
	if(typeof options === 'number') {
		lengthToTruncate = options;
	} else {
		lengthToTruncate = options.length
	}
	if(text.length > lengthToTruncate) {
		return text.slice(0, lengthToTruncate) + '...'
	}
	return text;
}

export const CONTENT_WINDOW_MESSAGE_EVENTS = {
	SHOW_MESSENGER: 'SHOW_MESSENGER',
	HIDE_MESSENGER: 'HIDE_MESSENGER',
};

export const PARENT_WINDOW_MESSAGE_EVENTS = {
	MESSENGER_LOADED: 'MESSENGER_LOADED',
	MESSENGER_ENTER_ANIMATION_COMPLETED: 'MESSENGER_ENTER_ANIMATION_COMPLETED',
	MESSENGER_EXIT_ANIMATION_COMPLETED: 'MESSENGER_EXIT_ANIMATION_COMPLETED',
};